angular
  .module('iqxCore')

  // Main controller for the wizard
  .controller('RegisterXCtrl', function ($scope, $q, FormSvc, ApiSvc, ApplicationSvc, $location, $routeParams) {
    $scope.wizardID = $routeParams.id || 'DEFAULT'
    $scope.wizardAction1 = $routeParams.action || (ApplicationSvc.isLoggedIn ? 'resume' : 'start')
    $scope.register = {} // Accumulate details
    $scope.register.source = $routeParams.source
    $scope.register.divisionEtc = $routeParams.division
    $scope.wizardPath = ''
    $scope.register.wizBackwards = false
    $scope.pagesize = 'normal'
    $scope.isCustomPage = false

    $scope.custompage = function (action = 'start', size = 'normal') {
      if (action == 'start') {
        $scope.isCustomPage = true
        $scope.pagesize = size
        return true
      }

      if (action == 'end') {
        $scope.isCustomPage = false
        $scope.page = 'normal'
        return true
      }
    }

    $scope.iconExists = function (icon) {
      if (icon) {
        var url = '/assets/registericons/' + icon + '.png'
        var request = new XMLHttpRequest()
        request.open('HEAD', url, false)
        request.send()
        if (request.status == 200 && request.responseURL.includes('.png')) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }

    $scope.getPage = function (pAction) {
      if (pAction == 'resume') {
        return $scope.CheckRegDetails().then(fetchPage(pAction))
      }
      return fetchPage(pAction)
    }

    function eu(s) {
      return encodeURIComponent(s)
    }

    function fetchPage(pAction) {
      var UL = ApplicationSvc.isLoggedIn ? '' : '_' // Underline must be removed once logged in or pWebUserID will not be filled
      return ApiSvc.fetch($scope, {
        fetchAPI: 'callresult' + UL + '/NetWizardGetPage?pWizardID=' + eu($scope.wizardID) + '&pAction=' + eu(pAction) + '&pPath=' + eu($scope.wizardPath),
        fetchTarget: 'wiz',
        notLoggedIn: true,
        multiRow: false,
        booleanFields: ['hasCheckBox', 'isLastPage'],
        numberFields: ['pageNumber', 'pageCount']
      })
        .then(function () {
          if ($scope.wiz.pageCount == null) {
            $location.url('/')
            throw new Error('Invalid Wizard ID - Please check to ensure you have followed a valid link.')
          }
          $scope.wiz.nextButtonEnabled = $scope.wiz.hasCheckBox ? false : true
          $scope.wiz.pageID = $scope.wiz.pageID || ''
          $scope.wizardPath = $scope.wiz.path || ''

          var segments = $scope.wiz.pageID.split('~')
          $scope.wiz.pageID = segments[0]
          $scope.wiz.pageOpts = []

          if (segments.length > 1) {
            $scope.wiz.pageOpts = segments.slice(1) // All arguments after the first part
          }
          var i = $scope.wiz.pageID.indexOf('_')
          if (i >= 0) {
            $scope.wiz.pageArgs = $scope.wiz.pageID.substr(i + 1)
            $scope.wiz.pageID = $scope.wiz.pageID.substr(0, i)
          } else {
            $scope.wiz.pageArgs = ''
          }
          $scope.wiz.pageID = $scope.wiz.pageID.toUpperCase()
          if (!$scope.wiz.pageID) {
            $scope.wizardFinished()
          }
        })
        .catch(function (e) {
          FormSvc.alert('Error', e.message, 'error')
        })
    }

    $scope.CheckRegDetails = function () {
      // Essential when resuming the wizard, to make sure that personid, division and department correctly reflect the saved data. Also to retrieve personid immediately after register
      if ($scope.register.PersonID) {
        return $q.when('Already fetched')
      } else {
        return ApiSvc.fetch($scope, { fetchAPI: 'callresult/NetCandidateRegDetails?pPersonID=' + (ApplicationSvc.currentUser.personID || ''), fetchTarget: 'RegDets', multiRow: false, booleanFields: ['DepartmentPerm', 'DepartmentTemp'] }).then(function () {
          angular.extend($scope.register, $scope.RegDets)
          if (!ApplicationSvc.currentUser.personID || ApplicationSvc.currentUser.personID == '') {
            ApplicationSvc.currentUser.personID = $scope.register.PersonID
          }
          $scope.RegDets = undefined
        })
      }
    }

    $scope.wizardFinished = function (dest) {
      var prom
      if (dest && dest != 'home') {
        ApplicationSvc.currentUser.UserClass = ''
      } else {
        ApplicationSvc.currentUser.UserClass = 'CANDIDATE'
        if ($scope.isSwitchedOn('PINAUTHALLOW') && $scope.isSwitchedOn('PINAUTHFORCE')) {
          dest = '/settings?createPIN=true&continue=%2F'
        } else {
          dest = 'home'
        }

        var procOpts = {}
        procOpts.pPersonID = ApplicationSvc.currentUser.personID
        if ($scope.wiz.pageOpts && $scope.wiz.pageOpts[0]) {
          procOpts.pNewCandState = $scope.wiz.pageOpts[0]
        }

        prom = $scope.exec('call/NetCandidateSetRegistrationComplete', procOpts)
      }
      $q.when(prom).then(function () {
        if ($routeParams.fromjobsearch) {
          window.opener.document.location.href = window.opener.document.location.href + '?authenticated=true'
          return window.close()
        }
        $location.url(dest)
      })
    }

    $scope.nextPage = function () {
      $scope.register.wizBackwards = false

      if ($scope.isCustomPage) {
        $scope.custompage('end')
      }

      if ($scope.wiz.isLastPage) {
        $scope.wizardFinished()
      } else {
        $scope.getPage('next')
      }
    }

    $scope.previousPage = function () {
      $scope.register.wizBackwards = true
      $scope.getPage('back')
    }

    $scope.skipPage = function () {
      // Can be called if page has no content
      if ($scope.register.wizBackwards && $scope.wiz.backButtonCaption) {
        $scope.previousPage()
      } else {
        $scope.nextPage()
      }
    }

    FormSvc.setOptions($scope, {
      autoEdit: true,
      notLoggedIn: true,
      doNotPreventNav: true
    })

    ApplicationSvc.currentUser.UserClass = 'PRE-CANDIDATE'
    $scope.getPage($scope.wizardAction1)
  })

  .controller('SoftRegisterEmail', function ($scope, FormSvc) {
    // Check Login Exists
    $scope.username = $scope.register.username || '' // In case going back in wizard

    $scope.checkLogin = function (login) {
      // Called by the Next button
      return $scope
        .fetch({
          fetchAPI: 'callresult_/NetCandCheckLoginStatus?pEmail=' + login,
          fetchTarget: 'logincheckrtrn',
          booleanFields: ['GotoLogin'],
          multiRow: false,
          notLoggedIn: true
        })
        .then(function () {
          if ($scope.logincheckrtrn.LoginError) {
            FormSvc.alert(false, $scope.logincheckrtrn.LoginError, 'error')
          }
          if ($scope.logincheckrtrn.GotoLogin) {
            $scope.wizardFinished('login?exists=true')
          } else if (!$scope.logincheckrtrn.LoginError) {
            $scope.register.username = login
            $scope.nextPage()
          }
        })
    }
  })

  .controller('SoftRegisterDetails', function ($scope, FormSvc, ApplicationSvc, loginSvc, ApiSvc) {
    // Personal Sign up Details
    // this will be changed to the standard register (without custom q's - i think)
    loginSvc.setLoggedOut() // If this page is visited we want to force logout before proceeding
    FormSvc.setOptions($scope, {
      fetchAPI: {
        /* Empty Fetch */
      },
      saveAPI: 'register/candidate',
      savePrefix: 'p',
      autoEdit: true,
      notLoggedIn: true,
      saveCleanFields: true
    })

    $scope.titlesForPayroll = [
      { Value: 'Mr', Descrip: 'Mr' },
      { Value: 'Mrs', Descrip: 'Mrs' },
      { Value: 'Ms', Descrip: 'Ms' },
      { Value: 'Miss', Descrip: 'Miss' },
      { Value: 'Dr', Descrip: 'Dr' },
      { Value: 'Prof', Descrip: 'Prof' },
      { Value: 'Rev', Descrip: 'Rev' }
    ]

    $scope.extraFields = {}
    $scope.SourceVisible = true
    $scope.passwordOpts()
    $scope.autocompleteResults = []
    $scope.autocompleteEnabled = $scope.params.ADDRESSLOOKUP
    $scope.addressLookupPlaceholder = $scope.autocompleteEnabled ? 'Start typing your address or postcode' : ''
    $scope.dateOptions.datepickerMode = 'year'
    $scope.dateOptions.initDate = moment().subtract('30', 'y').toDate()

    $scope.stash = function () {
      // Save page details on parent scope
      angular.extend($scope.register, { personDetails: $scope.theRecord, extraFields: $scope.extraFields })
    }

    $scope.previousPage = function () {
      $scope.stash()
      $scope.$parent.previousPage()
    }

    $scope.update = function () {
      // Over-ride the default update() called by the Next button
      if ($scope.theRecord.NINumber) {
        $scope.theRecord.NINumber = $scope.theRecord.NINumber.replace(/ /g, '')
      }
      // 10 char check on the UTR number.
      if ($scope.theRecord.UTR && $scope.theRecord.UTR.length !== 10 && $scope.params.REGUTR) {
        FormSvc.alert('', 'The UTR must be exactly 10 digits. No other characters are allowed.', 'error')
        return false
      }
      FormSvc.setSubmitted($scope, true)
      if ($scope.theForm.$valid) {
        return FormSvc.update($scope, true) // Save only - do not do the fetch
          .then(function (res) {
            ApplicationSvc.isEditing = false
            return loginSvc.setLoggedIn(res, true).then(function (loginstatus) {
              if (!$scope.userHasRight('LOGIN')) {
                window.location.reload() // Forces the noPermission page if they dont have login rights
              }
              ApplicationSvc.currentUser.UserClass = 'PRE-CANDIDATE'
            })
          })
          .then(function () {
            // save extra fields if needed!
            if ($scope.params.REGSOURCESELECT) {
              var extraFields = {}
              extraFields.pSourceID = $scope.extraFields.SourceID
              if ($scope.extraFields.Experience) {
                extraFields.pExperience = $scope.extraFields.Experience
              }
              return $scope.exec('call/NetCandidateSaveQuestions', extraFields)
            } else {
              return true
            }
          })
          .then(function () {
            // Division and department if specified in route or soft controller. This will suppress the relevant pages
            var divEtc = $scope.register.divisionEtc || $scope.wiz.divisionEtc
            if (divEtc) {
              var d = divEtc.split('_')
              return $scope
                .CheckRegDetails()
                .then(function () {
                  if (d[0] === '') {
                    return
                  }
                  $scope.register.DivisionID = d[0]
                  return $scope.exec('call/NetCandidateDivisionRegister', {
                    pPersonID: $scope.register.PersonID,
                    pDivisionID: d[0]
                  })
                })
                .then(function () {
                  if (d.length > 1) {
                    $scope.register.DepartmentID = d[1]
                    var rg = (d[2] || 'TP').toUpperCase()
                    return $scope.exec('call/NetCandidateDepartmentRegister', {
                      pdepartmentid: d[1],
                      ptemp: rg.indexOf('T') >= 0 ? 1 : 0,
                      pperm: rg.indexOf('P') >= 0 ? 1 : 0,
                      pPersonID: $scope.register.PersonID
                    })
                  }
                })
            }
          })
          .then(function () {
            $scope.stash()
            $scope.nextPage()
          })
      } else {
        FormSvc.alert(false, 'Please check that you have completed all the required fields and there are no invalid values', 'error')
      }
    }

    $scope.addressAutocomplete = async function (input) {
      if ($scope.autocompleteEnabled === false) {
        return
      }
      $scope.autocompleteResults[input] = null
      $scope.autocompleteResults[input] = await ApiSvc.exec($scope, 'addressLookup/autocomplete', { autocomplete: $scope.theRecord[input] }, true).catch((e) => {
        $scope.autocompleteResults = []
        $scope.autocompleteEnabled = false
      })
    }

    $scope.selectAddress = async function (address) {
      if ($scope.autocompleteEnabled === false) {
        return
      }
      $scope.autocompleteResults = []
      var fullAddress = await ApiSvc.exec($scope, 'addressLookup/getFull', { udprn: address.udprn }, true).catch((e) => {
        $scope.autocompleteResults = []
        $scope.autocompleteEnabled = false
      })
      updateAddressFields(fullAddress.IQXResult.Row)
    }

    function updateAddressFields(address) {
      $scope.theRecord.Addr1 = address.line_1
      $scope.theRecord.Addr2 = address.line_2
      $scope.theRecord.Addr3 = address.line_3
      $scope.theRecord.Town = address.post_town
      if ($scope.params.INCCOUNTY === true) {
        $scope.theRecord.County = address.county
      }
      if ($scope.params.INCCOUNTRY === true || $scope.params.OVERRIDECOUNTRY) {
        $scope.theRecord.Country = address.country
      }
      $scope.theRecord.Postcode = address.postcode
    }

    $scope.getRequiredFields = function () {
      return ApiSvc.fetch($scope, {
        fetchAPI: 'callresult_/NetGetRegRequired',
        fetchTarget: 'requiredFields',
        multiRow: false,
        notLoggedIn: true
      }).then(function () {
        $scope.requiredFields = JSON.parse($scope.requiredFields.JSON)
      })
    }

    $scope.getSourceDetails = function () {
      return $scope.fetch({
        fetchAPI: 'callresult_/NetCandidateSourceSelect',
        fetchTarget: 'sourceSelect',
        multiRow: true,
        notLoggedIn: true
      })
    }

    $scope
      .getRequiredFields()
      .then(function () {
        $scope.fetch() // Initialise
      })
      .then(function () {
        angular.extend($scope.theRecord, $scope.register.personDetails)
        $scope.extraFields = angular.extend({}, $scope.register.extraFields)
        $scope.theRecord.UserName = $scope.register.username
        $scope.theRecord.Email = $scope.register.username
        $scope.theRecord.RepeatEmail = $scope.register.username

        if ($scope.params.REGSOURCESELECT) {
          $scope.getSourceDetails().then(function () {
            if ($scope.sourceSelect.length === 0) {
              $scope.SourceVisible = false
            }
            if ($scope.register.source) {
              $scope.SourceVisible = false
              $scope.extraFields.SourceID = $scope.register.source
            }
          })
        }
      })
  })

  .controller('SoftRegisterRenewDetails', function ($scope, $location, FormSvc, ApiSvc) {
    // Renew Person Details

    $scope.userCanEdit = true
    $scope.caneditNI = $scope.userHasRight('CANEDITNI')
    $scope.lang = $scope.params.lang
    $scope.autocompleteResults = []
    $scope.autocompleteEnabled = $scope.params.ADDRESSLOOKUP
    $scope.addressLookupPlaceholder = $scope.autocompleteEnabled ? 'Start typing your address or postcode' : ''
    $scope.titlesForPayroll = [
      { Value: 'Mr', Descrip: 'Mr' },
      { Value: 'Mrs', Descrip: 'Mrs' },
      { Value: 'Ms', Descrip: 'Ms' },
      { Value: 'Miss', Descrip: 'Miss' },
      { Value: 'Dr', Descrip: 'Dr' },
      { Value: 'Prof', Descrip: 'Prof' },
      { Value: 'Rev', Descrip: 'Rev' }
    ]

    if ($scope.userHasRight('CANDHIDEDETAILSPAGE')) {
      $location.url('/noPermission')
    }

    if ($scope.userHasRight('CANDDETAILSREADONLY')) {
      var header = document.querySelectorAll('form .panel-heading .btn-primary')
      angular.forEach(header, function (elm, key) {
        header[key].setAttribute('class', 'hide')
      })

      var footer = document.querySelectorAll('form .panel-footer .btn-primary')
      angular.forEach(footer, function (elm, key) {
        footer[key].setAttribute('class', 'hide')
      })

      var formElements = document.querySelectorAll('form input')
      angular.forEach(formElements, function (elm, key) {
        formElements[key].setAttribute('ng-disabled', 'true')
      })
    }

    FormSvc.setOptions($scope, {
      fetchAPI: 'callresult/netcandidateprofile',
      saveAPI: 'call/netcandidateprofileset',
      savePrefix: 'p',
      saveWithPersonID: false, // is already in the record!
      fetchWithPersonID: true,
      autoEdit: true,
      dateFields: ['DOB'],
      booleanFields: ['OptInToMarketing'],
      primaryKey: 'PersonID'
    })

    $scope.dateOptions.datepickerMode = 'year'
    $scope.dateOptions.initDate = moment().subtract('30', 'y').toDate()

    $scope.doUpdate = function () {
      // Over-ride the default update() called by the Save & Submit button
      if ($scope.theRecord.NINumber) {
        $scope.theRecord.NINumber = $scope.theRecord.NINumber.replace(/ /g, '')
      }
      // 10 char check on the UTR number.
      if ($scope.theRecord.UTR && $scope.theRecord.UTR.length !== 10 && $scope.userHasRight('CANDUTR')) {
        FormSvc.alert('', 'The UTR must be exactly 10 digits. No other characters are allowed.', 'error')
        return false
      }
      FormSvc.setSubmitted($scope, true)
      return FormSvc.update($scope, false, false) // Do not do the fetch if submitted
        .then(function (err) {
          if (!err) {
            $scope.nextPage()
          }
        })
        .catch(function (err) {
          // Catch if a user is trying to change their email address to one that already exists!!
          if (err.iqxError.text === "[FireDAC][Phys][ODBC][SAP][ODBC Driver][SQL Anywhere]Index 'IQXNetUserEmailAddress' for table 'IQXNetUser' would not be unique") {
            FormSvc.alert('An account may already exist with that email address.', 'Please contact us to resolve this.', 'error')
          }
        })
    }
    $scope.update = $scope.doUpdate
    $scope.classes = { label: 'col-sm-10', data: 'col-sm-2' }

    $scope.addressAutocomplete = async function (input) {
      if ($scope.autocompleteEnabled === false) {
        return
      }
      $scope.autocompleteResults[input] = null
      $scope.autocompleteResults[input] = await ApiSvc.exec($scope, 'addressLookup/autocomplete', { autocomplete: $scope.theRecord[input] }).catch((e) => {
        $scope.autocompleteResults = []
        $scope.autocompleteEnabled = false
      })
    }

    $scope.selectAddress = async function (address) {
      if ($scope.autocompleteEnabled === false) {
        return
      }
      $scope.autocompleteResults = []
      var fullAddress = await ApiSvc.exec($scope, 'addressLookup/getFull', { udprn: address.udprn }).catch((e) => {
        $scope.autocompleteResults = []
        $scope.autocompleteEnabled = false
      })
      updateAddressFields(fullAddress.IQXResult.Row)
    }

    function updateAddressFields(address) {
      $scope.theRecord.Addr1 = address.line_1
      $scope.theRecord.Addr2 = address.line_2
      $scope.theRecord.Addr3 = address.line_3
      $scope.theRecord.Town = address.post_town
      if ($scope.params.INCCOUNTY === true) {
        $scope.theRecord.County = address.county
      }
      if ($scope.params.INCCOUNTRY === true || $scope.params.OVERRIDECOUNTRY) {
        $scope.theRecord.Country = address.country
      }
      $scope.theRecord.Postcode = address.postcode
    }

    $scope.fetch()
  })

  .controller('SoftRegisterEmailValidation', function ($scope, $routeParams) {
    // Email Validation
    $scope.wiz.nextButtonEnabled = false
    var emailAddress = $routeParams.validateEmail || ''

    function validateEmailmatch() {
      if (emailAddress) {
        if (atob(emailAddress) === $scope.register.EmailAddress) {
          $scope.wiz.nextButtonEnabled = true
          $scope.nextPage()
        } else {
          $scope.showError = true
        }
      }
    }

    $scope.$watch('register.EmailAddress', function (newValue, oldValue) {
      if (newValue) {
        validateEmailmatch()
      }
    })
  })

  .controller('SoftRegisterDivision', function ($scope, FormSvc) {
    // Divisions
    FormSvc.setOptions($scope, { fetchAPI: {}, doNotPreventNav: true, autoEdit: true })

    $scope.getDivisions = function () {
      return $scope.CheckRegDetails().then(function () {
        if ($scope.register.DivisionID) {
          return $scope.skipPage() // Division already selected
        } else {
          return $scope
            .fetch({
              fetchAPI: 'callresult/NetDivisionList',
              fetchTarget: 'DivisionList',
              multiRow: true
            })
            .then(function () {
              // check for icons and store flag in array for better render performance
              angular.forEach($scope.DivisionList, function (d) {
                d.iconExists = $scope.iconExists(d.DivisionID)
              })
            })
        }
      })
    }

    $scope.selectDivision = function (DIV) {
      return $scope
        .exec('call/NetCandidateDivisionRegister', {
          pPersonID: $scope.register.PersonID,
          pDivisionID: DIV
        })
        .then(function (res) {
          $scope.register.DivisionID = DIV
          $scope.nextPage()
        })
    }

    $scope.getDivisions()
  })

  .controller('SoftRegisterDepartment', function ($scope, $q, FormSvc, LanguageSvc) {
    // Departments
    FormSvc.setOptions($scope, { fetchAPI: {}, doNotPreventNav: true, autoEdit: true })

    $scope.getDepartments = function () {
      return $scope.CheckRegDetails().then(function () {
        if ($scope.register.DepartmentID) {
          return $scope.skipPage() // Department already selected
        } else {
          return $scope
            .fetch({
              fetchAPI: 'callresult/NetDepartmentList?pDivisionID=' + $scope.register.DivisionID,
              fetchTarget: 'DepartmentList',
              multiRow: true
            })
            .then(function () {
              // check for icons and store flag in array for better render performance
              angular.forEach($scope.DepartmentList, function (d) {
                d.iconExists = $scope.iconExists(d.DepartmentID)
              })
            })
        }
      })
    }

    $scope.selectDepartment = function (dept) {
      var prom
      let data = { department: dept.DepartmentID, deptName: dept.DepartmentName }
      data.temp = false
      data.perm = false
      if ($scope.wiz.pageArgs) {
        data.temp = $scope.wiz.pageArgs.indexOf('T') >= 0 ? true : false
        data.perm = $scope.wiz.pageArgs.indexOf('P') >= 0 ? true : false
      }
      if (data.temp || data.perm) {
        prom = $q.when(data)
      } else if ($scope.isSwitchedOn('DISABLEPERMREG') || $scope.isSwitchedOn('DISABLETEMPREG')) {
        prom = $q.when(data)
      } else {
        prom = FormSvc.modalForm($scope, 'deptTempOrPerm', data, 'md', { label: 'col-sm-3', data: 'col-sm-7' })
      }
      return prom.then(function (x) {
        if ($scope.isSwitchedOn('DISABLEPERMREG') || $scope.isSwitchedOn('DISABLETEMPREG')) {
          x.temp = !$scope.isSwitchedOn('DISABLETEMPREG')
          x.perm = !$scope.isSwitchedOn('DISABLEPERMREG')
        }

        if (x.temp == false && x.perm == false) {
          FormSvc.alert(false, 'You have to select either Temporary or Permanent to register for a' + LanguageSvc.lang.candidate.department + '.', 'error')
        } else {
          $scope.register.DepartmentID = x.department
          return $scope
            .exec('call/NetCandidateDepartmentRegister', {
              pdepartmentid: x.department,
              ptemp: x.temp ? 1 : 0,
              pperm: x.perm ? 1 : 0,
              pPersonID: $scope.register.PersonID
            })
            .then(function () {
              $scope.nextPage()
            })
        }
      })
    }

    $scope.getDepartments()
  })

  .controller('SoftRegisterBankDetails', function ($scope, FormSvc, ApiSvc) {
    // Bank Details
    FormSvc.setOptions($scope, { fetchAPI: {}, doNotPreventNav: true, autoEdit: true })

    $scope.agencyManagesDetails = false

    FormSvc.setOptions($scope, {
      fetchAPI: 'callresult/NetCandidateBankDetails',
      saveAPI: 'call/NetCandidateBankDetailsSet',
      saveWithPersonID: true,
      fetchWithPersonID: true,
      saveCleanFields: true,
      savePrefix: 'p',
      autoEdit: true,
      questionnaire: {
        tagTarget: 'tags',
        tagLocation: 'P',
        questionGroup: '-10',
        id: $scope.register.PersonID,
        postVar: 'qanswers'
      }
    })

    if (!$scope.userHasRight('CANDBANKDETAILSEDIT')) {
      var footer = document.querySelectorAll('form .panel-heading .btn-primary')
      angular.forEach(footer, function (elm, key) {
        footer[key].setAttribute('class', 'hide')
      })

      var formElements = document.querySelectorAll('form input')
      angular.forEach(formElements, function (elm, key) {
        formElements[key].setAttribute('ng-disabled', 'true')
      })
    }

    $scope.refreshVals = function () {
      $scope
        .fetch()
        .then(function () {
          return FormSvc.setEditing($scope, true)
        })
        .then(function () {
          if ($scope.theRecord.HideDetails == 1) {
            $scope.agencyManagesDetails = true
          }
        })
    }

    $scope.refreshVals()

    $scope.bankDetailsOk = async function () {
      if (!$scope.isSwitchedOn('CHECKBANKMODULUS')) {
        return true
      }
      if ($scope.theRecord.BankSortCode == $scope.cleanRecord.BankSortCode && $scope.theRecord.BankAcNo == $scope.cleanRecord.BankAcNo) {
        return true
      }
      let res = await ApiSvc.exec($scope, 'service/checkbankmodulus', { sortcode: $scope.theRecord.BankSortCode, accountnumber: $scope.theRecord.BankAcNo, iqxresult: 'Y' })
      let mess = res.IQXResult.message
      if (mess == 'Y') {
        return true
      }
      FormSvc.alert('Bank Details', mess + '\n\nIf you know the details are correct please contact the agency', 'error')
      return false
    }

    $scope.update = async function () {
      // If account number and sort code are blank ... we skippin
      if ((!$scope.theRecord.BankAcNo || $scope.theRecord.BankAcNo === '') && (!$scope.theRecord.BankSortCode || $scope.theRecord.BankSortCode === '')) {
        return $scope.nextPage()
      }

      if (!$scope.theRecord.BankAcNo || $scope.theRecord.BankAcNo === '' || $scope.theRecord.BankAcNo.length !== 8) {
        FormSvc.alert('', 'Account Number missing or incomplete', 'error')
        return false
      }
      //8 chars as there is 2 '-'
      if (!$scope.theRecord.BankSortCode || $scope.theRecord.BankSortCode === '' || $scope.theRecord.BankSortCode.length !== 8) {
        FormSvc.alert('', 'Sort Code missing or incomplete', 'error')
        return false
      }

      let bok = await $scope.bankDetailsOk()
      if (!bok) {
        return
      }
      return FormSvc.update($scope, true).then(function (res) {
        FormSvc.alert('Updated', 'Your bank details have been updated.', 'success')
        $scope.nextPage()
      })
    }
  })

  .controller('SoftRegisterTerms', function ($scope, FormSvc, $http, $q, $sce, ApplicationSvc, $templateRequest, TerminologySvc) {
    FormSvc.setOptions($scope, { fetchAPI: {}, doNotPreventNav: true, autoEdit: true })

    $scope.getFile = function (termsAndConditionsDocument) {
      $scope.TANDCsDocID = termsAndConditionsDocument
      return $http.get('/api/document/download', { params: { id: $scope.TANDCsDocID } }).then(
        function (doc) {
          let headers = doc.headers()
          if (headers['content-disposition'].indexOf('.html') >= 0) {
            $scope.TandCcontentType = 'html'
          } else {
            $scope.TandCcontentType = 'txt'
          }
          $scope.TandCcontent = $sce.trustAsHtml(doc.data)
        },
        function (error) {
          if ((error.status = 404)) {
            return $q.reject(error)
          } else {
            FormSvc.alert('Error', 'Error [' + error.status + '] ' + error.data, 'error')
          }
        }
      )
    }

    $scope.getTerms = function () {
      if ($scope.isSwitchedOn('SHOWTANDCONREG')) {
        $scope.CheckRegDetails().then(function () {
          var send = {
            pStage: 'O',
            pPersonID: $scope.register.PersonID
          }

          if ($scope.wiz.pageArgs) {
            send.pDocumentID = $scope.wiz.pageArgs
            send.pAdditonalDoc = 1
          } else {
            send.pDivisionID = $scope.register.DivisionID
            send.pDepartmentID = $scope.register.DepartmentID
          }

          return $scope
            .exec('call/NetCandidateDoTermsAndConditions', send)
            .then(function (r) {
              $scope.TermsAndConditions = r.IQXResult.IQXSuccess.attrs.id
              return $scope.getFile($scope.TermsAndConditions)
            })
            .catch(function (err) {
              $scope.skipPage()
            })
        })
      } else {
        $scope.skipPage()
      }
    }

    $scope.termsAndConditions = function (accepted) {
      TerminologySvc.getTerminology(['authRegister_refuseTermsAndConditionsMessage'])
        .then(function (terminology) {
          $scope.refuseMessage = terminology.authRegister_refuseTermsAndConditionsMessage
          if (accepted === 'accept') {
            return $scope
              .fetch({
                fetchAPI: 'callresult/NetCandidateDoTermsAndConditions?pStage=A&pDocumentID=' + $scope.TANDCsDocID,
                fetchTarget: 'AcceptTermsAndConditions',
                multiRow: false,
                fetchWithPersonID: true
              })
              .then(function () {
                $scope.nextPage()
              })
          } else if (accepted === 'later') {
            // if they don't want to make a decsion now.
            $templateRequest(`views/pagetext/regWizTerms-later.html`).then(function (template) {
              $scope.laterTemplate = template.trim()
            })
            var choices = [
              { desc: 'Decide Later', type: 'default', code: 'Y' },
              { desc: 'Go back', type: 'primary', code: '' }
            ]
            var data = { choices: choices }
            return FormSvc.modalInfo($scope, 'termsAndConditionsLater', data, 'sm').then(function (x) {
              switch (x) {
                case 'Y':
                  return (window.location.href = '/login?registerLater=true')
                  break

                case '':
                default:
                  // close the moooodal
                  break
              }
            })
          } else {
            // var choices = []
            $templateRequest(`views/pagetext/regWizTerms-rejected.html`).then(function (template) {
              $scope.rejectedTemplate = template.trim()
            })
            var choices = [
              { desc: 'I do not accept', type: 'danger', code: 'Y' },
              { desc: 'Go back', type: 'primary', code: '' }
            ]
            var data = { choices: choices }
            return FormSvc.modalInfo($scope, 'termsAndConditionsRefused', data, 'sm').then(function (x) {
              switch (x) {
                case 'Y':
                  return $scope.exec('call/NetCandidateDoTermsAndConditions', { pStage: 'R' }).then(function (res) {
                    return (window.location.href = '/login?registerRefused=true')
                  })
                  break

                case '':
                default:
                  // close the moooodal
                  break
              }
            })
          }
        })
        .catch(function (error) {
          console.error(error)
        })
    }

    $scope.getTerms()

    $scope.$watch('wiz.pageArgs', function (newValue, oldValue) {
      // If page switch moves from one questionnaire to another we need to force a re-init since the controller remains unchanged
      if (newValue == oldValue) {
        return
      } else {
        $scope.getTerms()
      }
    })
  })

  .controller('SoftRegisterSign', function ($scope, FormSvc, $http, $q, $sce, ApplicationSvc, $templateRequest, TerminologySvc, QuestionnaireSvc) {
    $scope.showForm = true
    $scope.showDoc = false
    $scope.showSigningMessage = false
    $scope.contactEventType = null
    $scope.documentType = null
    $scope.noQuestions = false

    FormSvc.setOptions($scope, {
      fetchAPI: {
        /* Empty Fetch */
      },
      saveAPI: 'call/netquestset',
      savePrefix: 'p',
      autoEdit: true
    })
    FormSvc.fetch($scope)

    $scope.validateAndSign = function () {
      if ($scope.theForm.$valid !== true) {
        return FormSvc.alert('Error', 'Please complete all the required fields', 'error')
      }

      $scope.qanswers = QuestionnaireSvc.answers($scope, { tagTarget: 'tags' })
      $scope.qAndA = {}

      // Include predefined answers
      $scope.tags.forEach((tag) => {
        if (tag.value && !$scope.qAndA[tag.tagid]) {
          if (tag.choices) {
            const choice = tag.choices.find((choice) => choice.tagchoiceid === tag.value)
            $scope.qAndA[tag.tagid] = {
              answer: tag.value,
              description: choice ? choice.description : tag.value
            }
          } else {
            $scope.qAndA[tag.tagid] = {
              answer: tag.value,
              description: tag.value
            }
          }
        }
      })

      const pairs = $scope.qanswers.split('&')
      if (pairs.toString() === '') {
        return $scope.getTerms()
      }
      pairs.forEach((pair) => {
        const [question, answer] = pair.split('__')[1].split('=')
        const decodedAnswer = decodeURIComponent(answer)
        const questionObj = $scope.tags.find((tag) => tag.tagid === question)
        if (questionObj && questionObj.choices) {
          const choice = questionObj.choices.find((choice) => choice.tagchoiceid === decodedAnswer)
          $scope.qAndA[question] = {
            answer: decodedAnswer,
            description: choice ? choice.description : decodedAnswer
          }
        } else {
          $scope.qAndA[question] = {
            answer: decodedAnswer,
            description: decodedAnswer
          }
        }
      })

      $scope.getTerms()
    }

    $scope.getQuestionnaire = function () {
      var hasQuestionniare = $scope.wiz.pageOpts[0].split(',').find((opt) => opt.startsWith('QG_'))

      if (!hasQuestionniare) {
        $scope.qanswers = ''
        $scope.qAndA = {}
        $scope.showDoc = true
        $scope.showForm = false
        $scope.noQuestions = true
        return $scope.getTerms()
      }

      return QuestionnaireSvc.fetch($scope, {
        tagTarget: 'tags',
        tagLocation: 'P',
        postVar: 'qanswers',
        displayGroup: $scope.wiz.pageOpts[0]
          .split(',')
          .find((opt) => opt.startsWith('QG_'))
          .replace('QG_', '')
      })
    }

    var substatuteVarsInHTML = function (html) {
      $scope.metaAttrs = $scope.wiz.pageOpts[0].split(',').filter((opt) => opt.startsWith('M_'))
      $scope.metaAttrs.forEach(function (opt) {
        if (opt === 'M_NAME') {
          html = html.replace(/\{\*NAME\*\}/g, ApplicationSvc.currentUser.UserName)
        }

        if (opt === 'M_EMAIL') {
          html = html.replace(/\{\*EMAIL\*\}/g, $scope.AdditionalData.email)
        }

        if (opt === 'M_ADDRESS') {
          html = html.replace(/\{\*ADDRESS\*\}/g, $scope.AdditionalData.addr1 + ' ' + $scope.AdditionalData.addr2 + ' ' + $scope.AdditionalData.addr3 + ' ' + $scope.AdditionalData.town + ' ' + $scope.AdditionalData.postcode)
        }

        if (opt === 'M_PHONE') {
          html = html.replace(/\{\*PHONE\*\}/g, $scope.AdditionalData.phone)
        }
      })

      // Global Replaces
      html = html.replace(/\{\*DATE\*\}/g, new Date().toLocaleDateString())
      html = html.replace(/\{\*TIME\*\}/g, new Date().toLocaleTimeString())
      html = html.replace(/\{\*TIMESTAMP\*\}/g, new Date().toLocaleString())

      // Deal with IF blocks inside the html document
      var ifBlockRegex = /\{\*IF_([A-Z0-9_]+)_([A-Z0-9_]+)\*\}([\s\S]*?)\{\*\/IF\*\}/g
      html = html.replace(ifBlockRegex, function (match, questionId, answerId, content) {
        if ($scope.qAndA[questionId] && $scope.qAndA[questionId].answer === answerId) {
          return content
        } else {
          return ''
        }
      })

      // Deal with question items
      Object.keys($scope.qAndA).forEach(function (tag) {
        // if the tag is a timestamp, format to dd/mm/yyyy
        if (moment.isDate($scope.qAndA[tag].description)) {
          $scope.qAndA[tag].description = moment($scope.qAndA[tag].description).format('DD/MM/YYYY')
        }

        html = html.replace(new RegExp('\\{\\*' + tag + '\\*\\}', 'g'), $scope.qAndA[tag].description)
      })
      // Remove anything left that is unanswered
      html = html.replace(/\{\*[A-Z0-9_]*\*\}/g, '')
      $scope.showDoc = true
      return html
    }

    $scope.getAdditonalCandData = function () {
      return $scope.fetch({
        fetchAPI: 'callresult/NetCandidateAdditionalDataForSigning',
        fetchTarget: 'AdditionalData',
        multiRow: false,
        fetchWithPersonID: true,
        autoEdit: true
      })
    }

    $scope.toggleFullScreen = function () {
      var elem = document.getElementById('tosReviewDev')
      if (elem.requestFullscreen) {
        elem.requestFullscreen()
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen()
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen()
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen()
      }
    }

    $scope.editQuestions = function () {
      $scope.showForm = true
      $scope.showDoc = false
      $scope.showSigningMessage = false
      $scope.TandCcontent = ''
    }

    $scope.getFile = function (termsAndConditionsDocument) {
      $scope.TANDCsDocID = termsAndConditionsDocument
      return $http.get('/api/document/download', { params: { class: 'G', id: $scope.TANDCsDocID } }).then(
        function (doc) {
          $scope.TandCcontentType = 'html'
          $scope.html = substatuteVarsInHTML(doc.data)
          $scope.TandCcontent = $sce.trustAsHtml($scope.html)
          $scope.showForm = false
        },
        function (error) {
          if (error.status == 404) {
            return $q.reject(error)
          } else {
            FormSvc.alert('Error', 'Error [' + error.status + '] ' + error.data, 'error')
          }
        }
      )
    }

    $scope.signDoc = function () {
      // Disable the button to prevent double submission
      $scope.showSigningMessage = true
      $scope.showDoc = false
      $scope.showForm = false

      // Save the questions back to the Candidate
      return $scope.exec('call/NetQuestSet', { qanswers: $scope.qanswers, pID: $scope.register.PersonID, pLocation: 'P' }).then(function () {
        // send the HTML ($scope.TandCcontent) to be PDF'd
        return $scope
          .exec('pdfTemplate/pdf', {
            html: $scope.html,
            pPersonID: $scope.register.PersonID,
            pDocumentName: $scope.documentName,
            pContactEventType: $scope.contactEventType,
            pDocumentType: $scope.documentType
          })
          .then(function (res) {
            if (res.IQXResult.attrs.success) {
              FormSvc.alert('Success', 'The document has been signed and saved', 'success')
              $scope.nextPage()
            } else {
              FormSvc.alert('Error', 'There was an error generating the signed PDF', 'error')
            }
          })
          .catch(function (err) {
            $scope.showSigningMessage = false
            $scope.showDoc = true
            $scope.showForm = false
            console.error(err)
          })
      })
    }

    $scope.getTerms = function () {
      $scope.CheckRegDetails().then(function () {
        var send = {
          pStage: 'O',
          pPersonID: $scope.register.PersonID
        }

        if ($scope.wiz.pageArgs) {
          send.pDocumentID = $scope.wiz.pageArgs
          send.pAdditonalDoc = 1
        } else {
          send.pDivisionID = $scope.register.DivisionID
          send.pDepartmentID = $scope.register.DepartmentID
        }

        return $scope
          .exec('call/NetCandidateGetSignDocument', send)
          .then(function (r) {
            $scope.TermsAndConditions = r.IQXResult.IQXSuccess.attrs.id
            $scope.documentName = r.IQXResult.IQXSuccess.attrs.message
            return $scope.getFile($scope.TermsAndConditions)
          })
          .catch(function (err) {
            console.error(err)
            $scope.skipPage()
          })
      })
    }

    $scope.termsAndConditions = function (accepted) {
      TerminologySvc.getTerminology(['authRegister_refuseTermsAndConditionsMessage'])
        .then(function (terminology) {
          $scope.refuseMessage = terminology.authRegister_refuseTermsAndConditionsMessage
          if (accepted === 'later') {
            // if they don't want to make a decsion now.
            $templateRequest(`views/pagetext/regWizSigning-later.html`).then(function (template) {
              $scope.laterTemplate = template.trim()
            })
            var choices = [
              { desc: 'Decide Later', type: 'default', code: 'Y' },
              { desc: 'Go back', type: 'primary', code: '' }
            ]
            var data = { choices: choices }
            return FormSvc.modalInfo($scope, 'signingLater', data, 'sm').then(function (x) {
              switch (x) {
                case 'Y':
                  return (window.location.href = '/login?registerLater=true')
                  break

                case '':
                default:
                  // close the moooodal
                  break
              }
            })
          } else {
            var choices = [
              { desc: 'I do not accept', type: 'danger', code: 'Y' },
              { desc: 'Go back', type: 'primary', code: '' }
            ]
            var data = { choices: choices }
            return FormSvc.modalInfo($scope, 'signingRefused', data, 'sm').then(function (x) {
              switch (x) {
                case 'Y':
                  return (window.location.href = '/login')
                  break

                case '':
                default:
                  // close the moooodal
                  break
              }
            })
          }
        })
        .catch(function (error) {
          console.error(error)
        })
    }

    $scope.init = function () {
      try {
        $scope.contactEventType = $scope.wiz.pageOpts[0]
          .split(',')
          .find((opt) => opt.startsWith('CTE_'))
          .replace('CTE_', '')
      } catch (error) {
        // Supress error
        console.info(error)
      }
      try {
        $scope.documentType = $scope.wiz.pageOpts[0]
          .split(',')
          .find((opt) => opt.startsWith('DT_'))
          .replace('DT_', '')
      } catch (error) {
        // Supress error
        console.info(error)
      }
      return $scope.getAdditonalCandData().then($scope.getQuestionnaire)
    }

    $scope.init()

    $scope.$watch('wiz.pageArgs', function (newValue, oldValue) {
      // If page switch moves from one questionnaire to another we need to force a re-init since the controller remains unchanged
      if (newValue == oldValue) {
        return
      } else {
        $scope.init()
      }
    })
  })

  .controller('SoftRegisterQuestions', function ($scope, $q, ApiSvc, FormSvc) {
    // Questionnaire

    $scope.nextPage = function () {
      // Over-ride default. Allows us to use the standard footer buttons
      FormSvc.update($scope).then(function () {
        $scope.$parent.nextPage()
      })
    }

    function eu(s) {
      return encodeURIComponent(s)
    }

    $scope.getCustomQgroup = function (qParms) {
      // If displayGroup ends with a dot then invoke SoftWizardQuestionGroup to modify it
      if (qParms.displayGroup && qParms.displayGroup.substr(-1) == '.') {
        return ApiSvc.fetch($scope, {
          fetchAPI: 'callresult/SoftWizardQuestionGroup?pPersonID=' + eu($scope.register.PersonID) + '&pTagGroupID=' + eu(qParms.displayGroup) + '&pDivisionID=' + eu($scope.register.DivisionID) + '&pDepartmentID=' + eu($scope.register.DepartmentID),
          fetchTarget: 'customQgroup'
        }).then(function () {
          qParms.displayGroup = $scope.customQgroup.TagGroupID || qParms.displayGroup
        })
      } // Otherwise return undefined to leave it unchanged
    }

    $scope.init = function () {
      if ($scope.wiz.pageArgs) {
        $scope.tags = []
        $scope
          .CheckRegDetails()
          .then(function () {
            var qParms = { tagTarget: 'tags' }
            var argArr = $scope.wiz.pageArgs.replace(/[$]/g, $scope.register.DepartmentID).split('_')
            qParms.tagLocation = argArr[0]
            if (argArr.length > 1) {
              qParms.displayGroup = argArr[1]
            }
            qParms.id = $scope.register.PersonID
            qParms.postVar = 'qanswers'
            return $q.when($scope.getCustomQgroup(qParms)).then(function () {
              FormSvc.setOptions($scope, {
                fetchAPI: {
                  /* Empty Fetch */
                },
                saveAPI: 'call/netquestset',
                savePrefix: 'p',
                autoEdit: true,
                questionnaire: qParms
              })
              return FormSvc.fetch($scope)
            })
          })
          .then(function () {
            if ($scope.tags.length == 0) {
              $scope.skipPage()
            }
          })
          .then(function () {
            $scope.pagetextFile = 'regWizQuestions_' + $scope.wiz.pageArgs.replace('?', '').replace(/[$]/g, $scope.register.DepartmentID)
          })
      } else {
        $scope.skipPage()
      }
    }

    $scope.$watch('wiz.pageArgs', function (newValue, oldValue) {
      // If page switch moves from one questionnaire to another we need to force a re-init since the controller remains unchanged
      $scope.init()
    })
  })

  .controller('SoftRegisterCVandPhoto', function ($scope, FormSvc, ApplicationSvc, ApiSvc, $timeout, Upload) {
    // File Uploader

    $scope.init = function () {
      $scope.uploader = { CV: {}, photo: {} }

      $scope.uploader.CV.allowed = $scope.isSwitchedOn('WIZARDUPLOADERCV')

      $scope.uploader.photo.allowed = $scope.isSwitchedOn('WIZARDUPLOADERPHOTO')

      if (!($scope.uploader.CV.allowed || $scope.uploader.photo.allowed)) {
        $scope.skipPage()
        return
      }

      $scope.uploader.CV.docType = 'primary_cv'
      $scope.uploader.photo.docType = 'primary_photo'

      FormSvc.setOptions($scope, { fetchAPI: {}, doNotPreventNav: true, autoEdit: true })

      $scope.uploader.CV.required = $scope.isSwitchedOn('WIZARDUPLOADERREQCV')

      $scope.uploader.photo.required = $scope.isSwitchedOn('WIZARDUPLOADEREQPHOT')

      $scope.params.REGISTRATIONTYPE = $scope.params.REGISTRATIONTYPE || {}

      $scope.uploader.CV.pdfAllowed = $scope.isSwitchedOn('WIZARDALLOWPDFCV')

      if ($scope.uploader.CV.pdfAllowed) {
        $scope.CVuploadTypes = [
          {
            value: 'primary_cv',
            descrip: 'Document (.pdf, .doc, .docx)',
            accept: '.pdf,.doc,.docx'
          }
        ]
      } else {
        $scope.CVuploadTypes = [
          {
            value: 'primary_cv',
            descrip: 'Document (.doc, .docx)',
            accept: '.doc,.docx'
          }
        ]
      }

      if ($scope.params.PDFCVDOCTYPE) {
        $scope.CVuploadTypes.push({
          value: $scope.params.PDFCVDOCTYPE,
          descrip: 'Portable Document Format (.pdf)'
        })
      }

      $scope.setNextButtonState()
      $scope.CheckRegDetails() // Make sure personID is loaded
    }

    $scope.setNextButtonState = function () {
      $scope.wiz.nextButtonEnabled = !(($scope.uploader.CV.required && !$scope.uploader.CV.done) || ($scope.uploader.photo.required && !$scope.uploader.photo.done))
    }

    $scope.uploadSelect = function (which) {}

    $scope.uploadComplete = function (which) {
      $scope.uploader[which].done = true
      $scope.uploader[which].progress = ''
      $scope.uploader[which].error = ''
      $scope.uploader[which].file = undefined
      $scope.setNextButtonState()
    }

    $scope.uploadFileName = function (which) {
      if ($scope.uploader[which].file) {
        return $scope.uploader[which].file.name
      } else {
        return 'Select ' + which
      }
    }

    $scope.showUploadProgress = function (evt) {
      var s = 'Uploading ...'
      if (evt && evt.total) {
        // progress callback
        s = s + parseInt((100.0 * evt.loaded) / evt.total) + '%'
      }
      $scope.uploader[evt.config.id].progress = s
    }

    $scope.uploadExecute = function (which) {
      if (!$scope.uploader[which].file) {
        return
      }
      var fn = $scope.uploader[which].file.name
      switch ($scope.uploader[which].docType) {
        case 'primary_photo':
          if (!fn.match(/jpe?g$/i)) {
            return ($scope.uploader[which].error = 'Invalid file: must be a JPEG')
          }
          break
        case 'primary_cv':
          if ($scope.uploader.CV.pdfAllowed) {
            if (!fn.match(/docx?|pdf$/i)) {
              return ($scope.uploader[which].error = 'Invalid file: must be a DOCX, DOC or PDF')
            }
            break
          } else if (!$scope.uploader.CV.pdfAllowed) {
            if (!fn.match(/docx?$/i)) {
              return ($scope.uploader[which].error = 'Invalid file: must be a DOCX or DOC')
            }
            break
          }

        case $scope.params.PDFCVDOCTYPE:
          if (!fn.match(/pdf$/i)) {
            return ($scope.uploader[which].error = 'Invalid file: must be a PDF')
          }
          break
      }
      $scope.uploader[which].error = ''
      $scope.showUploadProgress({ config: { id: which } })
      Upload.upload({
        url: '/api/document/upload',
        file: $scope.uploader[which].file,
        fileFormDataName: 'file',
        id: which,
        headers: { 'X-Auth': ApplicationSvc.currentUser.token },
        fields: {
          Type: $scope.uploader[which].docType,
          Description: which,
          PersonID: ApplicationSvc.currentUser.personID
        }
      })
        .then(
          function (res) {
            ApiSvc.CheckIQXResult(res.data) // Checks the IQXResult construct and, if failed, throws exception with the message
            $scope.uploader[which].progress = 'Upload Complete'
            return $timeout(function () {}, 2000) // Display the Upload complete message for 2 seconds before refreshing and cleaning up
          },
          null,
          $scope.showUploadProgress
        ) // 3rd arg is the progress callback
        .then(function () {
          $scope.uploadComplete(which)
        })
        .catch(function (err) {
          var e
          if (err.iqxError) {
            e = err.iqxError.text
          } else {
            e = 'Error uploading file'
          }
          $scope.uploader[which].file = undefined
          $scope.uploader[which].progress = ''
          $scope.uploader[which].error = e
        })
    }

    $scope.init() // Initialise
  })

  .controller('SoftRegisterVideoInterview', function ($scope, $timeout, FormSvc, ApplicationSvc, ApiSvc, Upload, SweetAlert) {
    $scope.showInterview = false
    $scope.recorded = false
    $scope.recording = false

    $scope.displayTimeLimit = function () {
      if ($scope.params.RECTIMELIMIT < 60) {
        return $scope.params.RECTIMELIMIT + ' seconds'
      } else {
        return ($scope.params.RECTIMELIMIT / 60).toFixed(2) + ' minute(s)'
      }
    }

    var video = document.querySelector('video')
    var recorder

    $scope.toggleVideo = function () {
      $scope.showInterview = !$scope.showInterview
    }

    function captureCamera(callback) {
      navigator.mediaDevices
        .getUserMedia({
          audio: true,
          video: {
            width: $scope.params.RECWIDTH,
            height: $scope.params.RECHEIGHT
          }
        })
        .then(function (camera) {
          callback(camera)
        })
        .catch(function (error) {
          console.error(error)
          SweetAlert.swal({
            title: 'Error',
            text: 'Error getting camera.\n\n' + error,
            type: 'error'
          })
        })
    }

    function stopRecordingCallback() {
      video.src = video.srcObject = null
      video.muted = false
      video.volume = 1
      $scope.videoblob = recorder.getBlob()
      video.src = URL.createObjectURL($scope.videoblob)

      recorder.camera.stop()
      recorder.destroy()
      recorder = null
    }

    $scope.startVideo = function () {
      $scope.showInterview = true
      $scope.recording = true
      $scope.recorded = false
      video.removeAttribute('controls')

      captureCamera(function (camera) {
        video.muted = true
        video.volume = 0
        video.srcObject = camera

        recorder = RecordRTC(camera, {
          type: 'video',
          mimeType: 'video/webm;codecs=vp8',
          disableLogs: true
        })

        recorder.setRecordingDuration($scope.params.RECTIMELIMIT * 1000).onRecordingStopped(function () {
          // 💩
          $timeout(function () {
            $scope.recorded = true
            $scope.recording = false
          }, 100)
          video.setAttribute('controls', '')
          recorder.stopRecording(null)
          return stopRecordingCallback()
        })
        recorder.startRecording()
        recorder.camera = camera
      })
    }

    $scope.stopVideo = function () {
      // 💩
      $timeout(function () {
        $scope.recorded = true
        $scope.recording = false
      }, 100)
      video.setAttribute('controls', '')

      recorder.stopRecording(stopRecordingCallback)
    }

    $scope.uploadVidExecute = function () {
      if ($scope.recorded !== true) {
        return FormSvc.alert(false, 'You have to record a video before uploading.', 'error')
      }
      $scope.uploadNotification = 'Uploading...'
      $scope.uploadError = ''
      Upload.upload({
        url: '/api/document/upload',
        file: $scope.videoblob,
        fileFormDataName: 'file',
        headers: {
          'X-Auth': ApplicationSvc.currentUser.token
        },
        fields: {
          Type: ApplicationSvc.params.RECDOCTYPEID,
          Description: moment().format('DD/MM/YYYY HH:mm') + ' - Video Interview ' + $scope.userName(),
          PersonID: ApplicationSvc.currentUser.personID
        }
      })
        .then(
          function (res) {
            ApiSvc.CheckIQXResult(res.data) // Checks the IQXResult construct and, if failed, throws exception with the message
            $scope.uploadProgress = 'Upload complete'
            return $timeout(function () {}, 2000) // Display the Upload complete message for 2 seconds before refreshing and cleaning up
          },
          null,
          $scope.showUploadProgress
        ) // 3rd arg is the progress callback

        .then(function () {
          if ($scope.isSwitchedOn('POPUPDOCUPDISABLE')) {
            return true
          }
          return $scope.exec('call/NetMessage', {
            ptype: 'DOCUMENTUPLOAD',
            ptitle: $scope.userName() + ' Video Interview Uploaded',
            pdescription: ''
          })
        })
        .then(function () {
          FormSvc.alert('Video Uploaded', 'Your video interview has been uploaded\n\nA consultant will review the video before it is available on the web.', 'success')
          $scope.showInterview = !$scope.showInterview
          $scope.uploadNotification = undefined
          $scope.nextPage()
        })
        .catch(function (err) {
          $scope.uploadProgress = ''
          FormSvc.alert('Upload Error', err.iqxError.text, 'error')
          return $q.reject(($scope.uploadError = ApiSvc.ExtractError(err)))
        })
    }

    $scope.submitVideo = function () {
      $scope.uploadVidExecute()
    }
  })

  .controller('SoftRegisterReferences', function ($scope, FormSvc, base64Svc, QuestionnaireSvc, $timeout, ApplicationSvc) {
    FormSvc.setOptions($scope, { fetchAPI: {}, doNotPreventNav: true, autoEdit: true })
    $scope.refSelected = false
    var questionsScope = {}

    $scope.getWebRefTypes = function () {
      return $scope
        .fetch({
          fetchAPI: 'callresult/NetGetWebReferenceTypes',
          fetchTarget: 'webRefTypes',
          multiRow: true,
          autoEdit: true,
          doNotPreventNav: true
        })
        .then(function () {
          // remove the nulls ...
          $scope.webRefTypes = $scope.webRefTypes.filter((r) => r.WebRefTypeName)
        })
    }

    $scope.refName = function (refID) {
      if (refID === 0 || !refID) {
        return 'Generic'
      }
      refID = refID || $scope.refSelected
      return $scope.webRefTypes.filter((r) => r.WebRefTypeID === refID)[0].WebRefTypeName
    }

    $scope.referenceTypeChanged = function (scope) {
      $scope.refSelected = scope.theRecord.referenceType

      return QuestionnaireSvc.fetch(scope, {
        // Fetch linked questions (compliance docs functionality)
        tagTarget: 'tags',
        tagLocation: 'R' + $scope.register.DepartmentID,
        postVar: 'qanswers',
        questionGroup: scope.refSelected,
        alwaysShowQGroup0: true
      })
        .then(function () {
          if (scope.tags && scope.tags.length) {
            QuestionnaireSvc.reset(scope, { tagTarget: 'tags' }) // Ensure in pristine state
            $timeout(
              function () {
                // Must be done after fully loaded
                QuestionnaireSvc.linkFormFields(scope, { tagTarget: 'tags' })
                scope.$broadcast('isEditing', true)
                ApplicationSvc.isEditing = true
              },
              0,
              true,
              true
            )
          }
        })
        .then(function () {
          questionsScope = scope
        })
    }

    $scope.getWebReferences = function () {
      return $scope.fetch({
        fetchAPI: 'callresult/NetGetWebReferences',
        fetchTarget: 'webReferences',
        multiRow: true,
        fetchWithPersonID: true,
        autoEdit: true,
        booleanFields: ['AskCandidateBeforeSend']
      })
    }

    $scope.addReference = function () {
      return FormSvc.modalForm($scope, 'addReferenceForm', {}, 'lg', { label: 'col-sm-3', data: 'col-sm-7' })
        .then(function (formData) {
          $scope.qanswers = QuestionnaireSvc.answers(questionsScope, { tagTarget: 'tags' })
          return $scope.exec('call/NetSetWebReference', {
            pPersonID: $scope.register.PersonID,
            pDepartmentID: $scope.register.DepartmentID,
            pRefereeAddressName: formData.refereename,
            pRefereeSalutation: formData.refereesalutation,
            pRefereePosition: formData.refereeposition,
            pCompanyName: formData.refereecompanyname,
            pAddr1: formData.refereeaddress1,
            pAddr2: formData.refereeaddress2,
            pAddr3: formData.refereeaddress3,
            pTown: formData.refereetown,
            pCounty: formData.refereecounty,
            pCountry: formData.refereecountry,
            pPostCode: formData.refereepostcode,
            pHomePhone: formData.refereehomephone,
            pWorkPhone: formData.refereeworkphone,
            pMobilePhone: formData.refereemobilephone,
            pFax: formData.refereefax,
            pEmail: formData.refereeemail,
            pPosition: formData.jobtitle ? formData.jobtitle : '',
            pURLRequestCode: base64Svc.encode(`${$scope.register.PersonID}|${formData.refereeemail}|${moment().toISOString()}`),
            pStartDate: formData.startdate,
            pEndDate: formData.enddate,
            pRefType: $scope.refSelected,
            pAskCandidateBeforeSend: formData.dontSendImmediately ? 1 : 0,
            qanswers: $scope.qanswers
          })
        })
        .then(function () {
          $scope.refSelected = false
          QuestionnaireSvc.reset(questionsScope, { tagTarget: 'tags' })
        })
        .then(function () {
          FormSvc.alert('Reference Added', '', 'success')
        })
        .then($scope.getWebReferences)
        .catch(function (e) {
          $scope.refSelected = false
          QuestionnaireSvc.reset(questionsScope, { tagTarget: 'tags' })
        })
    }

    $scope.deleteReference = function (ref) {
      return $scope
        .exec('call/NetDeleteWebReference', {
          pReferenceRequestID: ref.ReferenceRequestID,
          pPersonID: $scope.register.PersonID
        })
        .then(function (resp) {
          if (resp.IQXResult.attrs.success === '1') {
            FormSvc.alert('Success', 'Reference removed successfully.', 'success')
          } else {
            FormSvc.alert('Error', 'Something went wrong removing the reference.', 'error')
          }
        })
        .then($scope.getWebReferences)
    }

    $scope.CheckRegDetails().then($scope.getWebRefTypes).then($scope.getWebReferences)
  })

  .controller('SoftRegisterDocumentUploader', function ($scope, $q, $timeout, FormSvc, ApplicationSvc, ApiSvc, QuestionnaireSvc, Upload) {
    // Document Uploader

    FormSvc.setOptions($scope, {
      fetchAPI: 'callresult/netcandidatedocuments' + ($scope.PersonID ? '?pPersonID=' + $scope.PersonID : ''),
      multiRow: true,
      doNotPreventNav: true,
      saveWithPersonID: $scope.PersonID ? false : true,
      fetchWithPersonID: $scope.PersonID ? false : true,
      dateFields: ['LastUpdate']
    })

    if ($scope.isSwitchedOn('WIZARDVALIDATEDOCS')) {
      $scope.wiz.nextButtonEnabled = false
    }

    $scope.theRecord = {}

    $scope.changedType = function () {
      angular.forEach($scope.uploadTypes, function (ut) {
        if (ut.Value === $scope.theRecord.Type) {
          $scope.theRecord.Description = ut.Description
        }
      })
      $scope.tags = []
      if (!$scope.userHasRight('DOCQUESTIONNAIRE')) {
        return $q.when('No questionnaire') // Return a promise in case chaining required
      }
      return QuestionnaireSvc.fetch($scope, {
        // Fetch linked questions (compliance docs functionality)
        tagTarget: 'tags',
        tagLocation: 'P',
        documentType: $scope.theRecord.Type,
        id: $scope.xPerson.PersonID
      })
        .then(function () {
          if ($scope.tags && $scope.tags.length) {
            QuestionnaireSvc.reset($scope, { tagTarget: 'tags' }) // Ensure in pristine state
            $timeout(
              function () {
                // Must be done after fully loaded
                QuestionnaireSvc.linkFormFields($scope, { tagTarget: 'tags' })
                $scope.$broadcast('isEditing', true)
              },
              0,
              true,
              true
            )
          }
        })
        .catch(function (e) {})
    }

    $scope.uploadSelect = function (files, file, event) {
      $scope.theForm.file.$touched = true // Show any validation error on the selected file
    }

    $scope.uploadCleanup = function () {
      $scope.reset()
      $scope.uploadProgress = ''
      $scope.uploadError = ''
      $scope.theRecord = {}
      $scope.tags = []
    }

    $scope.uploadFileName = function () {
      if ($scope.theRecord.file) {
        return $scope.theRecord.file.name
      } else {
        return 'Select file..'
      }
    }

    $scope.showUploadProgress = function (evt) {
      var s = 'Uploading...'
      if (evt && evt.total) {
        // progress callback
        s = s + parseInt((100.0 * evt.loaded) / evt.total) + '%'
      }
      $scope.uploadProgress = s
    }

    $scope.triggerUploadUI = function () {
      $scope.setEditing(true)
      if ($scope.isSwitchedOn('WIZARDVALIDATEDOCS')) {
        $scope.wiz.nextButtonEnabled = false
      }
    }

    $scope.uploadExecute = function () {
      $scope.setSubmitted(true) // Ensure all validation errors appear
      if ($scope.uploadProgress || $scope.theForm.$invalid) {
        return
      }
      $scope.uploadError = ''
      $scope.showUploadProgress()
      Upload.upload({
        url: '/api/document/upload',
        file: $scope.theRecord.file,
        fileFormDataName: 'file',
        headers: { 'X-Auth': ApplicationSvc.currentUser.token },
        fields: {
          Type: $scope.theRecord.Type,
          Description: $scope.theRecord.Description,
          PersonID: $scope.xPerson.PersonID
        }
      })
        .then(
          function (res) {
            ApiSvc.CheckIQXResult(res.data) // Checks the IQXResult construct and, if failed, throws exception with the message
            $scope.uploadProgress = 'Upload complete'
            return $timeout(function () {}, 2000) // Display the Upload complete message for 2 seconds before refreshing and cleaning up
          },
          null,
          $scope.showUploadProgress
        ) // 3rd arg is the progress callback
        .then(function () {
          if ($scope.tags && $scope.tags.length) {
            // Save the questionnaire
            $scope.qanswers = QuestionnaireSvc.answers($scope, { tagTarget: 'tags' })
            return $scope.exec('call/NetQuestSet', { qanswers: $scope.qanswers, pID: $scope.xPerson.PersonID, pLocation: 'P' })
          }
        })
        .then(function () {
          if ($scope.isSwitchedOn('POPUPDOCUPDISABLE')) {
            return true
          }
          return $scope.exec('call/NetMessage', {
            ptype: 'DOCUMENTUPLOAD',
            ptitle: $scope.userName() + ' ' + $scope.theRecord.Description + ' Uploaded',
            pdescription: ''
          })
        })
        .then(function () {
          FormSvc.alert('File Uploaded', 'Your file has been uploaded.', 'success')
          return $scope.fetch() // Refresh the list
        })
        .then(function () {
          $scope.uploadCleanup()
        })
        .catch(function (err) {
          $scope.uploadProgress = ''
          FormSvc.alert('Upload Failed', err.iqxError.text, 'error')
          return $q.reject(($scope.uploadError = ApiSvc.ExtractError(err)))
        })
    }

    $scope.validateDocuments = function () {
      return $scope
        .exec('call/NetWizardValidateDocuments', {
          pWizardID: $scope.wizardID,
          pPersonID: ApplicationSvc.currentUser.personID
        })
        .then(function (res) {
          $scope.wiz.nextButtonEnabled = true
          FormSvc.alert('Document Check', 'All documents are OK', 'success')
        })
        .catch(function () {
          $scope.wiz.nextButtonEnabled = false
        })
    }

    $scope
      .fetch()
      .then(function () {
        return $scope.fetch({
          fetchAPI: 'callresult/netuploadtypes?pOwnerType=P',
          fetchTarget: 'uploadTypes',
          multiRow: true
        })
      })
      .then(function () {
        if ($scope.PersonID) {
          // Sec Agency - we need the candidate name
          return $scope.fetch({ fetchAPI: 'callresult/netcandidateprofile?pPersonID=' + $scope.PersonID, fetchTarget: 'xPerson' })
        } else {
          // If any documents were downloaded take the first PersonID from them
          $scope.xPerson = { PersonID: $scope.PersonID ? $scope.PersonID : ApplicationSvc.currentUser.personID }
        }
      })
      .then(function () {
        if ($scope.xPerson.Forenames) {
          $scope.xPerson.Fullname = FormSvc.getFirstWord($scope.xPerson.Forenames) + ' ' + $scope.xPerson.Surname
        }
      })
  })

  .controller('SoftRegisterEmploymentHistory', function ($scope, FormSvc) {
    // Employment History
    FormSvc.setOptions($scope, {
      fetchAPI: 'callresult/NetCandidateGetEmploymentHistory',
      multiRow: true,
      doNotPreventNav: true,
      fetchWithPersonID: true,
      dateFields: ['startdate', 'leavedate'],
      booleanFields: ['temp']
    })

    $scope.expand = function (empHistory) {
      var choices = [{ desc: 'Close', type: 'primary', code: '' }]
      var data = { empHistory: empHistory, choices: choices }
      FormSvc.modalInfo($scope, 'empHisInfo', data, 'md')
    }

    $scope.addHistory = function () {
      return FormSvc.modalForm($scope, 'addEmploymentHistoryForm', {}, 'lg', { label: 'col-sm-3', data: 'col-sm-7' }).then(function (formData) {
        var postObj = {
          pPersonID: $scope.register.PersonID,
          pcompanyname: formData.companyname,
          pstartdate: moment(formData.startdate).toISOString(),
          ptemp: formData.temp,
          pnote: formData.notes,
          psalary: formData.salary,
          pposition: formData.position
        }
        if (formData.leavedate) {
          postObj.pleavedate = moment(formData.leavedate).toISOString()
        }
        return $scope
          .exec('call/NetCandidateSetEmploymentHistory', postObj)
          .then(function (resp) {
            if (resp.IQXResult.attrs.success !== '1') {
              FormSvc.alert('Error', 'Something went wrong while adding your employment history, please try again.', 'error')
            }
          })
          .then($scope.getEmplotmentHistory)
      })
    }

    $scope.deleteHistory = function (his) {
      return $scope
        .exec('call/NetCandidateDeleteEmploymentHistory', {
          pextemploymentid: his.extemploymentid,
          pPersonID: $scope.register.PersonID
        })
        .then(function (resp) {
          if (resp.IQXResult.attrs.success === '1') {
            FormSvc.alert('Success', 'History removed successfully.', 'success')
          } else {
            FormSvc.alert('Error', 'Something went wrong removing the history record.', 'error')
          }
        })
        .then($scope.getEmplotmentHistory)
    }

    $scope.getEmplotmentHistory = function () {
      return $scope.fetch()
    }

    $scope.fetch()
  })
